// De brieven in de keuzelijst 'Sjabloon' op de briefpagina: eerst de eigen
// brieven die Deccos voor de organisatie klaarzette (gesorteerd op naam, dan
// voor → na → output), daarna de standaardbrieven uit de app. Heeft de
// organisatie de tekst van een standaardbrief aangepast (LetterTemplates met
// TemplateKey 'standaard', geschreven door saveLetterTemplate), dan staat die
// eigen versie op de plek van die standaardbrief — niet ernaast.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

// Spiegel van functions/letters/letterTemplates.js (DEFAULT_KEY, pariteitstest).
const DEFAULT_KEY = 'standaard'
const KIND_ORDER = { voor: 0, na: 1, output: 2, storytelling: 3 }

/**
 * @typedef {object} LetterTemplate
 * @property {string} ID
 * @property {string} TemplateKey - 'standaard' of de sleutel van een eigen brief
 * @property {string} MomentKind - voor | na | output
 * @property {string} Label
 * @property {string} [Title]
 * @property {string} Body
 * @property {string} [CompagnyID] - Alleen bij een document uit LetterTemplates
 */

/**
 * Welke brief is dit, los van het document dat hem draagt. Blijft gelijk als
 * de standaardbrief na het opslaan een eigen document wordt.
 *
 * @param {LetterTemplate} template
 * @returns {string}
 */
const letterIdentity = (template) => `${template.TemplateKey}__${template.MomentKind}`

/**
 * @param {Array<LetterTemplate>|string} docs - LetterTemplates van de organisatie; '' zolang ze laden
 * @param {Array<LetterTemplate>} defaults - De standaardbrieven uit de app
 * @returns {Array<LetterTemplate>}
 */
const mergeLetterTemplates = (docs, defaults) => {
    const list = Array.isArray(docs) ? docs : []
    const own = list
        .filter((t) => t.TemplateKey !== DEFAULT_KEY)
        .sort((a, b) => String(a.Label || '').localeCompare(String(b.Label || ''))
            || (KIND_ORDER[a.MomentKind] ?? 3) - (KIND_ORDER[b.MomentKind] ?? 3))
    const standard = defaults.map((d) =>
        list.find((t) => t.TemplateKey === DEFAULT_KEY && t.MomentKind === d.MomentKind) || d)
    return [...own, ...standard]
}

export { DEFAULT_KEY, letterIdentity }
export default mergeLetterTemplates
